import {Dashboard} from "@mui/icons-material"
import i18n from 'i18next';

// ==============================|| DASHBOARD MENU ITEMS ||============================== //

const getDashboard = () => ({
    id: 'dashboard',
    type: 'group',
    children: [
        {
            id: 'home',
            title: i18n.t('sidemenu.dashboard'),
            type: 'item',
            url: '/home',
            icon: Dashboard,
            breadcrumbs: false,
        },
    ]
});

export default getDashboard;